import CustomQuote from "../../../../components/quotes/CustomQuote.vue"
import QuickQuote from "../../../../components/quotes/QuickQuote.vue"

export default [
    {
        path: '/custom_quote/create/:lead_id',
        name: 'CreateCustomQuote',
        meta: { layout: 'mystagit', company_record: { type: 'lead', param: 'lead_id' } },
        component: CustomQuote,
    },
    {
        path: '/quote/edit/:lead_id/:quote_id',
        name: 'EditCustomQuote',
        meta: { layout: 'mystagit', company_record: { type: 'quote', param: 'quote_id' } },
        component: CustomQuote,
    },
    {
        path: '/quick_quote/create/:lead_id',
        name: 'CreateQuickQuote',
        meta: { layout: 'mystagit', company_record: { type: 'lead', param: 'lead_id' } },
        component: QuickQuote,
    }
]